import AreYouSureButtons from "Components/molecule/are-you-sure-buttons";
import { SelectOption } from "Components/molecule/inputs/select-input";
import Modal from "Components/molecule/modal";
import Breadcrumb from 'Components/organisms/breadcrumb';
import RocksForm from "Components/organisms/forms/rocks-form";
import RocksFields from "Components/organisms/forms/rocks-form/types";
import LoadingState from "Components/organisms/loading-state";
import FormProps from "data/forms";

import { Container } from "reactstrap"

interface RocksFormTemplateProps extends FormProps<RocksFields> {
    years: SelectOption[]
    quarters: SelectOption[]
    employees: SelectOption[]
    status?: SelectOption[]
    isLoadingRock?: boolean
    breadcrumbItem: string
    title: string
    subtitle: string
}


const RocksFormTemplate = ({
    values,
    errors,
    touched,
    isValid,
    isSubmitting,
    breadcrumbItem,
    title,
    subtitle,
    years,
    quarters,
    employees,
    status,
    edit,
    isLoadingRock = false,
    handleBlur,
    handleChange,
    handleSubmit,
    handleCancel,
}: RocksFormTemplateProps) => {
    return <div className="page-content">
        <Container fluid className="section-container">
            <Breadcrumb
                title="Business Development"
                breadcrumbItem={breadcrumbItem}
            />
            <div className="section-container">
                {isLoadingRock ?
                    <LoadingState
                        title="Loading form"
                        subtitle="Getting the boulders out of the way...."
                    />
                    :
                    <>
                        <div>
                            <h4>{title}</h4>
                            <h6>{subtitle}</h6>
                        </div>
                        <RocksForm
                            edit={edit}
                            values={values}
                            errors={errors}
                            touched={touched}
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            handleSubmit={handleSubmit}
                            isValid={isValid}
                            isSubmitting={isSubmitting}
                            handleCancel={handleCancel}
                            status={status}
                            years={years}
                            quarters={quarters}
                            employees={employees}
                        />
                    </>
                }
            </div>
        </Container>
    </div>
}

export default RocksFormTemplate